import { inboxApi } from '../api'
import * as pushNotificationBrowserStrategy from './push-notifications-browser.js'
import * as pushNotificationNativeAppleStrategy from './push-notifications-native-apple.js'

function getSupportedStrategy() {
  if (pushNotificationBrowserStrategy.isSupported()) {
    return pushNotificationBrowserStrategy
  }

  if (pushNotificationNativeAppleStrategy.isSupported()) {
    return pushNotificationNativeAppleStrategy
  }

  return null
}

export function isSupported() {
  return getSupportedStrategy() != null
}

export async function createSubscription(inboxServerHost) {
  const strategy = getSupportedStrategy()

  return await strategy.createSubscription(inboxServerHost)
}

export async function revokeSubscription() {
  const strategy = getSupportedStrategy()

  return await strategy.revokeSubscription()
}

export async function checkPermissions() {
  const strategy = getSupportedStrategy()

  if (!isSupported()) {
    // If no strategy is supported, it should still return truthy permission,
    // as this triggers the remote fetch to check if the inbox server has a subscription.
    // TODO: Refine this because of weird logic.
    return true
  }

  return await strategy.checkPermissions()
}

export async function reRegisterIfNeeded(inboxServerHost) {
  if (!isSupported()) {
    return
  }

  try {
    // Check if the user has push enabled on the inbox server
    const response = await inboxApi.accountRequests.get()
    const json = await response.json()
    if (!json.hasPushSubscription) {
      return
    }

    // Check local permissions before attempting to subscribe
    const strategy = getSupportedStrategy()
    const permissionsGranted = await strategy.checkPermissions()

    if (permissionsGranted) {
      const subscription = await strategy.createSubscription(inboxServerHost)
      await inboxApi.accountRequests.updatePushSubscription(subscription)
    }
  } catch (error) {
    console.error('Failed to aggressively re-register for push notifications:', error)
  }
}

